import React from "react";
import * as ReactDOM from "react-dom/client";
import { setRootUrl } from "@miplatform/api";
import { MsalProvider } from "@azure/msal-react";
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/600.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import App from "./App";
import { buildMsalAuthConfig, registerMsalEventCallback } from "./msal";

window.global ||= window;

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const render = async () => {
  await setRootUrl();
  const config = await buildMsalAuthConfig();
  if (!config) {
    return;
  }
  registerMsalEventCallback(config);
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={config.msalInstance}>
        <App authConfig={config} />
      </MsalProvider>
    </React.StrictMode>
  );
};

render();
